export default {
  // Navigation
  'nav.timer': 'Timer',
  'nav.stopwatch': 'Stoppuhr',
  'nav.worldclock': 'Weltuhr',
  'nav.timestamp': 'Zeitstempel',
  'nav.home': 'Startseite',

  // Common buttons and actions
  'button.start': 'Starten',
  'button.pause': 'Pause',
  'button.stop': 'Stop',
  'button.reset': 'Zurücksetzen',
  'button.ok': 'OK',
  'button.cancel': 'Abbrechen',
  'button.close': 'Schließen',
  'button.save': 'Speichern',
  'button.delete': 'Löschen',
  'button.edit': 'Bearbeiten',
  'button.back': 'Zurück',
  'button.next': 'Nächster',
  'button.previous': 'Vorheriger',
  'button.submit': 'Einreichen',
  'button.confirm': 'Bestätigen',
  'button.convert': 'Umwandeln',
  'button.copy': 'Kopieren',
  'button.copied': 'Kopiert!',
  'button.now': 'Jetzt',
  'button.clear': 'Löschen',

  // Common labels
  'label.hours': 'Stunden',
  'label.minutes': 'Minuten',
  'label.seconds': 'Sekunden',
  'label.milliseconds': 'Millisekunden',
  'label.minute': 'Minute',
  'label.second': 'Sekunde',
  'label.sound': 'Ton',
  'label.soundAlert': 'Ton',
  'label.fullscreen': 'Vollbild',
  'label.language': 'Sprache',
  'label.selectLanguage': 'Sprache wählen',
  'label.languageSelectorInfo': 'Unterstützt derzeit {{count}} Sprachen. Wählen Sie Ihre bevorzugte Sprache aus den obigen Optionen.',

  // Common messages
  'message.timerComplete': 'Timer abgelaufen!',
  'message.timerCompleteDesc': 'Ihr Timer ist abgelaufen',
  'message.timerCompleteBody': 'Ihr Countdown-Timer ist abgelaufen!',
  'message.stopwatchStarted': 'Stoppuhr gestartet',
  'message.stopwatchStartedDesc': 'Stoppuhrzählung wurde gestartet',
  'message.stopwatchStopped': 'Stoppuhr gestoppt',
  'message.stopwatchStoppedDesc': 'Stoppuhrzählung wurde unterbrochen',
  'message.stopwatchReset': 'Stoppuhr zurückgesetzt',
  'message.stopwatchResetDesc': 'Stoppuhr wurde auf Null zurückgesetzt',
  'message.notificationPermission': 'Benachrichtigungen zulassen, um Benachrichtigungen zu erhalten, wenn der Timer endet',
  'message.clickToEdit': 'Klicken Sie auf die Zeitnummern, um die Zeit direkt zu bearbeiten',
  'message.addHours': '+ Stunden hinzufügen',
  'message.escToExit': 'Drücken Sie ESC, um das Vollbild zu beenden',
  'message.timeRemaining': '{{minutes}} Minuten {{seconds}} Sekunden verbleibend',
  'message.minutesRemaining': '{{minutes}} Minuten verbleibend',
  'message.secondsRemaining': '{{seconds}} Sekunden verbleibend',
  'message.stopwatchTimeElapsed': '{{minutes}} Minuten {{seconds}} Sekunden vergangen',
  'message.stopwatchMinutesElapsed': '{{minutes}} Minuten vergangen',
  'message.stopwatchSecondsElapsed': '{{seconds}} Sekunden vergangen',
  'message.invalidTimestamp': 'Ungültiger Zeitstempel',
  'message.invalidDateTime': 'Ungültiges Datum und Zeit',
  'message.conversionError': 'Konvertierungsfehler',

  // Time units
  'time.am': 'AM',
  'time.pm': 'PM',
  'time.now': 'Jetzt',
  'time.today': 'Heute',
  'time.yesterday': 'Gestern',
  'time.tomorrow': 'Morgen',

  // Common errors
  'error.pageNotFound': 'Seite nicht gefunden',
  'error.somethingWrong': 'Etwas ist schief gelaufen',
  'error.tryAgain': 'Bitte versuchen Sie es später erneut',

  // Footer
  'footer.about': 'Über timer.today',
  'footer.aboutDesc': 'timer.today ist eine professionelle Online-Timing-Tool-Plattform mit drei Kernfunktionen:',
  'footer.timerDesc': 'Anpassbares Countdown-Tool mit Unterstützung für Minuten- und Stundeneinstellungen, perfekt für Arbeitsfokus, Kochzeitmessung, Lernverwaltung und vieles mehr. Bietet Soundbenachrichtigungen und Desktop-Benachrichtigungen.',
  'footer.stopwatchDesc': 'Hochpräzisions-Zeitmess-Tool mit Millisekundengenauigkeit, geeignet für Sporttraining, Kochvorgänge, Prüfungstraining und andere Szenarien, die präzise Zeitmessung erfordern.',
  'footer.worldClockDesc': 'Echtzeit-Anzeige der Zeiten großer Städte weltweit mit intelligenten Zeitzonenberechnungen, erleichtert internationale Geschäftskommunikation und zeitzonenübergreifende Zusammenarbeit.',
  'footer.timestampDesc': 'Unix-Zeitstempel-Konverter unterstützt bidirektionale Konvertierung zwischen Zeitstempel und Datum/Zeit mit Unterstützung für Sekunden- und Millisekundenformat.',
  'footer.termsOfService': 'Nutzungsbedingungen',
  'footer.privacy': 'Datenschutz',
  'footer.contactUs': 'Kontaktieren Sie uns',
  'footer.changeLanguage': 'Sprache wechseln',
  'footer.moreLanguage': 'mehr Sprachen',
  'footer.copyright': '© timer.today 2024',

  // Quick actions
  'quick.add30s': '+30 Sek',
  'quick.add1min': '+1 Min',
  'quick.add5min': '+5 Min',
  'quick.add10min': '+10 Min',
  'quick.add30min': '+30 Min',

  // Breadcrumb
  'breadcrumb.minuteTimer': '{{minutes}}-Minuten-Timer',
  'breadcrumb.timer': 'Timer',
  'breadcrumb.stopwatch': 'Stoppuhr',
  'breadcrumb.worldClock': 'Weltuhr',
  'breadcrumb.termsOfService': 'Nutzungsbedingungen',
};